angular.module('unica_notification.notification_services')

.factory('NotificationListService', function($http, getBaseApiURL) {

	var notificationListService = {};

	notificationListService.list = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.notifications;
			}

		});
	};

	notificationListService.get = function (notificationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/detail/' + notificationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.notificationGroup;
			}

		});

	};

	return notificationListService;

});